/**
 * Bob mesh data exports
 * Auto-generated - do not edit manually
 */

import type { BobMesh, BobMaterials } from "./types.js";
export type { BobMesh, BobMaterials } from "./types.js";

import { BOB_MESHES, BOB_MATERIALS } from "./bob.js";

export const BOB_MESHES_EXPORT = BOB_MESHES;
export const BOB_MATERIALS_EXPORT = BOB_MATERIALS;

export function getBobMeshes(): BobMesh[] {
  return BOB_MESHES;
}

export function getBobMaterials(): BobMaterials {
  return BOB_MATERIALS;
}
